import React from 'react';
import './contact.css';

import Navbar from '../../Components/Navbar/Navbar'
import Footer from '../../Components/Footer/Footer'
import ContactForm from '../../Components/Contact/ContactForm/ContactForm';
import Connect from "../../Components/Contact/Connets";
import ContactBanner from '../../Components/Contact/ContactBanner';


const ContactUs = () => {
    return (
        <div>
            <Navbar />
            <div className='h-[200px]'>
                <ContactBanner />
            </div>
            <ContactForm />
            <Connect />
            <Footer />
        </div>
    )
}

export default ContactUs;